import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input } from '@angular/core';
import { getPassengerLabel, isEmptyObject, isStringEmpty } from '@common/helpers';
import { Meal } from '@common/interfaces/mybooking/order-services.interface';
import { FlightMealService } from '@common/services/my-booking/flight-meal-service/flight-meal-service';
import { SupportComponent } from '@lib/components/support-class';
import { CommonLibService } from '@lib/services';
import { Subscription } from 'rxjs';
import { Bound, GetMealResponseData, GetOrderResponseData } from 'src/sdk-servicing';
import { Traveler } from 'src/sdk-servicing/model/traveler';
import { Type1 } from 'src/sdk-servicing/model/type1';

@Component({
  selector: 'asw-flight-meal-traveler',
  templateUrl: './flight-meal-traveler.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FlightMealTravelerComponent extends SupportComponent {
  _subscriptions: Subscription = new Subscription();
  @Input() traveler!: Traveler;
  passengerTypeLabel!: string;
  flightsList: Type1[] = [];
  pnr!: GetOrderResponseData;
  meal!: GetMealResponseData;
  constructor(
    private _common: CommonLibService,
    public _changeDetectorRef: ChangeDetectorRef,
    private _flightMealService: FlightMealService
  ) {
    super(_common);
  }

  init(): void {
    this._subscriptions.add(
      this._flightMealService.inFlightMealRequestData$.subscribe((data) => {
        this.pnr = data.pnr ?? ({} as GetOrderResponseData);
        this.meal = data.meal ?? ({} as GetMealResponseData);
        this.flightsList = this.getFlightInformationToGetMeal();

        // Save data to handle Event number 9
        this._flightMealService.flightsList = this.flightsList;
        // [1.2.5] 当該搭乗者情報.passengerTypeCodeに応じた文言
        this.passengerTypeLabel = getPassengerLabel(this.traveler?.passengerTypeCode ?? '');
        this._changeDetectorRef.markForCheck();
      })
    );
  }

  /**
   * [1.2] <以下、サービシング共通store.PNR情報取得API応答.data.air.bounds.flightsの二重で繰り返し>(それぞれ要素が当該セグメント情報)
   * 搭乗者別機内食情報.<当該セグメント情報.Id>をセグメント別機内食情報とする。セグメント別機内食情報が存在する場合、以降の項目を設定する。
   */
  getFlightInformationToGetMeal() {
    const flightInformation: Type1[] = [];
    const flights =
      this.pnr?.air?.bounds?.flatMap((bound: Bound) => bound.flights ?? ([] as Type1[])) ?? ([] as Type1[]);
    flights?.forEach((flight) => {
      if (isEmptyObject(this.meal?.[this.traveler.id!]?.[flight.id!]) !== true) {
        // [1.2.6.1.1] 該セグメント情報.isJapanDomesticFlight=true(日本国内線)かつ、当該セグメント別機内食情報. meals.mealCodeが存在しない場合は非表示とする。
        if (Boolean(flight.isJapanDomesticFlight === true && isStringEmpty(flight?.meal?.mealCode)) === false) {
          // [1.2.6.1.2] 上記以外の場合、サービシング共通store.PNR情報取得API応答.data.services.meal.<当該セグメント情報.Id>.<isAvailable=true>.<当該搭乗者情報.Id>である情報を申込済機内食情報とする。
          const servicesMeal = this.pnr?.services?.meal as Meal;
          if (servicesMeal?.[String(flight.id)]?.isAvailable) {
            flightInformation.push(flight);
          }
        }
      }
    });
    return flightInformation;
  }

  // [1.2.4] 当該搭乗者情報.names[0].title +" "(半角スペース)+ 当該搭乗者情報.names[0].firstName +" " (半角スペース)+ 当該搭乗者情報.names[0].lastName
  get passengerName() {
    return this.traveler?.names?.[0];
  }
  reload(): void {}
  destroy(): void {
    if (this._subscriptions) {
      this._subscriptions.unsubscribe();
    }
  }
}
